import $ from 'jquery';
import { updateCSRFTokenFromHeader } from '../utilities/csrf_token_provider';

let apiOrigin = '';

class API {
  static setApiOrigin(origin) {
    apiOrigin = origin;
  }

  static FETCH_GET(url) {
    const origin =
      (window.location.origin || `${window.location.protocol}//${window.location.hostname}`) + TYROOLA.globals.baseUrl;
    const absoluteUrl = (apiOrigin || origin) + url;
    return fetch(absoluteUrl);
  }

  static FETCH_POST(url, data = {}) {
    const origin =
      (window.location.origin || `${window.location.protocol}//${window.location.hostname}`) + TYROOLA.globals.baseUrl;
    const absoluteUrl = (apiOrigin || origin) + url;
    return fetch(absoluteUrl, {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  static request({ apiPath, type, data, dataType, contentType }) {
    const origin =
      (window.location.origin || `${window.location.protocol}//${window.location.hostname}`) + TYROOLA.globals.baseUrl;
    const url = (apiOrigin || origin) + apiPath;
    const ajaxResponse = $.ajax({
      url,
      type,
      data,
      dataType,
      contentType,
      success: function (data, textStatus, request) {
        updateCSRFTokenFromHeader(request);
      },
      error: function (request, textStatus, errorThrown) {
        updateCSRFTokenFromHeader(request);
      }
    });

    return ajaxResponse;
  }

  static GET(options) {
    let { apiPath, data, dataType } = options;
    data = data || '';

    return API.request({ apiPath, type: 'get', data, dataType });
  }

  static GET_REST(options) {
    let { apiPath, urlParams, data, dataType } = options;
    data = data || '';
    urlParams = urlParams || '';

    const restUrl = apiPath + urlParams.join('/') + '/';
    return API.request({ apiPath: restUrl, type: 'get', data, dataType });
  }

  static POST(options) {
    let { apiPath, data, dataType, contentType } = options;
    data = data || '';

    return API.request({ apiPath, type: 'post', data, dataType, contentType });
  }

  static PUT(options) {
    let { apiPath, data, dataType, contentType } = options;
    data = data || '';

    return API.request({ apiPath, type: 'put', data, dataType, contentType });
  }

  static DELETE(options) {
    let { apiPath, data, dataType, contentType } = options;
    data = data || '';

    return API.request({ apiPath, type: 'delete', data, dataType, contentType });
  }
}

export { API };
export default API;
